<!-- prettier-ignore -->

<p class="office-access">
    {{ '¿Te registraste en una oficina de turismo?' | translate }}

    @if (sent()) {
        <span class="office-access__sent">{{ 'Te hemos enviado un enlace de acceso a tu correo' | translate }}</span>
    } @else {
        <button type="button" class="office-access__action" [disabled]="sending()" (click)="send()">
            {{ 'Te enviamos un enlace de acceso' | translate }}
        </button>
    }
</p>
